import { network } from 'services/network';

export const getQRCode = ({ email }) => {
    const url = `admin/bo/getQRCode/${email}`;
    return network
        .get(url, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers.Accept = 'image/png';
                    }
                    return data;
                },
            ],
            responseType: 'blob',
        })
        .then((response) => {
            return response.data;
        });
};
